<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="fullweeklyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold">Employee attendances</small>
              </legend>
              <form @submit.prevent="loadEmployeeAttendance()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control full_From_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control full_End_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button type="button" class="btn btn-danger btn-flat" data-dismiss="modal">
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingEmployeeAttendances"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingEmployeeAttendancesLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small class="font-size:15px; font-weight: bold">manage employees</small>
      </legend>
       <button
        type="button"
        class="btn btn-success btn-roundec"
        data-toggle="modal"
        data-target="#fullweeklyexpensesModal"
      >
        <i class="fa fa-file-pdf-o"></i> General attendances
      </button>
      <p></p>
      <div></div>
      <div>
        <div class="employeesLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>
          loading employees...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemEmployees"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'rows per page',
            ofLabel: 'of',
            pageLabel: 'page', //for 'pages' mode
            allLabel: 'all'
          }"
        ></vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Employee no",
          field: "employee_no",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter emp number"
          }
        },
        {
          label: "Employee name",
          field: "employee_name"
        },
        {
          label: "Id no",
          field: "id_no"
        },
        {
          label: "Phone no",
          field: "phone_no"
        }
      ]
    };
  },
  created() {
    this.loadEmployees();
  },
  computed: {
    ...mapGetters(["systemEmployees"])
  },
  methods: {
    ...mapActions(["loadEmployees", "loadEmployeeAttendance"])
  }
};
</script>
<style scoped>
.creatingEmployeeAttendancesLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/reports/employeeattendances.vue